function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, h5, h4, button, .MuiTypography-root, .MuiTab-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

function findTab(text) {
	const tabs = document.querySelectorAll('.MuiTab-root')
	for (const t of tabs) {
		if (t.textContent.trim().toLowerCase().includes(text.toLowerCase())) return t
	}
	return null
}

function findTableColumn(headerText) {
	const headers = document.querySelectorAll('th, [class*="MUIDataTableHeadCell"]')
	for (const h of headers) {
		if (h.textContent.trim().toLowerCase().includes(headerText.toLowerCase())) {
			return h
		}
	}
	return null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'bell',
		title: ES ? 'Bienvenido a Notificaciones de Alerta' : 'Welcome to Alert Notifications',
		description: ES
			? 'Las Notificaciones de Alerta muestran los resultados de tus condiciones de alerta. Cuando la ejecucion de un informe coincide con una condicion que definiste, la notificacion aparece aqui con todos los detalles — fecha de recogida, LOR, categoria, proveedor, diferencia de precio y mas.'
			: 'Alert Notifications show the results of your alert conditions. When a report execution matches a condition you defined, the notification appears here with full details — pickup date, LOR, category, provider, price difference, and more.',
	},
	{
		type: 'field',
		findTarget: () => {
			const tabs = document.querySelector('.MuiTabs-root')
			return tabs || findTab('Price Comparison')?.closest('.MuiTabs-root')
		},
		icon: 'layer-group',
		title: ES ? 'Pestanas de Tipo de Alerta' : 'Alert Type Tabs',
		description: ES
			? 'Cambia entre tipos de notificacion. Cada pestana muestra las notificaciones activadas por el tipo de condicion correspondiente. Los datos se cargan de forma independiente para cada pestana cuando seleccionas un informe y una oficina.'
			: 'Switch between notification types. Each tab shows notifications triggered by the corresponding condition type. The data loads independently for each tab when you select a report and office.',
		example: ES
			? 'Comparacion de Precios | No Disponible | Cambio de Precio | Min y Max | Valoracion'
			: 'Price Comparison | Not Available | Price Change | Min & Max | Rating',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Please, select a report') || findByText('Must select a report')
			if (el) {
				const form = el.closest('.MuiFormControl-root') || el.closest('.MuiAutocomplete-root')
				if (form) return form.closest('.MuiGrid-item')?.parentElement || form
			}
			const selects = document.querySelectorAll('.MuiAutocomplete-root')
			if (selects.length) return selects[0].closest('.MuiGrid-item')?.parentElement || selects[0]
			return null
		},
		icon: 'filter',
		title: ES ? 'Filtro de Informe y Oficina' : 'Report & Office Filter',
		description: ES
			? 'Primero selecciona un informe, luego una oficina. Las notificaciones son especificas de una ejecucion de informe y oficina de recogida. El desplegable de oficinas se carga automaticamente tras seleccionar un informe, preseleccionando la opcion mas relevante.'
			: 'First select a report, then an office. Notifications are specific to a report execution and pickup office. The office dropdown loads automatically after selecting a report, pre-selecting the most relevant option.',
		example: ES
			? 'Paso 1: Seleccionar Informe → Paso 2: Seleccionar Oficina → Se cargan los datos'
			: 'Step 1: Select Report → Step 2: Select Office → Data loads',
	},
	{
		type: 'field',
		findTarget: () => findTab('Price Comparison'),
		icon: 'hand-holding-dollar',
		title: ES ? 'Notificaciones de Comparacion de Precios' : 'Price Comparison Notifications',
		description: ES
			? 'Muestra cuando el precio de un competidor es mas barato, mas caro o difiere en una cantidad establecida respecto a tu sitio principal. Cada fila incluye los detalles completos del coche, sitios, proveedores y la diferencia de precio exacta.'
			: 'Shows when a competitor\'s price is cheaper, more expensive, or differs by a set amount compared to your main site. Each row includes full car details, sites, providers, and the exact price difference.',
	},
	{
		type: 'field',
		findTarget: () => findTab('Not Available'),
		icon: 'circle-xmark',
		title: ES ? 'Notificaciones de No Disponible' : 'Not Available Notifications',
		description: ES
			? 'Alerta cuando una categoria de coche o proveedor deja de estar disponible. Muestra la fecha de recogida, LOR, categoria, ACRISS y que sitio/proveedor tiene la falta de disponibilidad.'
			: 'Alerts when a car category or provider becomes unavailable. Shows the pickup date, LOR, category, ACRISS, and which site/provider has the availability gap.',
	},
	{
		type: 'field',
		findTarget: () => findTab('Price Change'),
		icon: 'money-bill-1-wave',
		title: ES ? 'Notificaciones de Cambio de Precio' : 'Price Change Notifications',
		description: ES
			? 'Se activa cuando los precios suben o bajan mas alla de tu umbral. Muestra tanto el precio anterior como el actual, el porcentaje de cambio y un enlace para ver la busqueda en Tiempo Real.'
			: 'Triggered when prices increase or decrease beyond your threshold. Shows both the previous and current price, the percentage change, and a link to view the search in Real Time.',
	},
	{
		type: 'field',
		findTarget: () => findTab('Min & Max Price'),
		icon: 'plus-minus',
		title: ES ? 'Notificaciones de Min y Max' : 'Min & Max Notifications',
		description: ES
			? 'Se activa cuando un precio cruza los limites definidos — por encima del maximo o por debajo del minimo. Util para detectar errores de precios o movimientos extremos del mercado.'
			: 'Fires when a price crosses your defined boundaries — above maximum or below minimum thresholds. Useful for catching pricing errors or extreme market movements.',
	},
	{
		type: 'field',
		findTarget: () => findTab('Rating'),
		icon: 'star-half-stroke',
		title: ES ? 'Notificaciones de Valoracion' : 'Rating Notifications',
		description: ES
			? 'Muestra cuando las valoraciones de proveedores cambian mas alla de tus condiciones. Presenta el sitio, proveedor y puntuacion con indicadores de estrellas.'
			: 'Shows when provider ratings change beyond your conditions. Displays the site, provider, and rating score with star indicators.',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Percentage') || findByText('Currency') || findByText('Cheaper')
			if (!el) return null
			let parent = el.parentElement
			for (let i = 0; i < 5; i++) {
				if (!parent) break
				if (parent.children.length >= 2) {
					const text = parent.textContent.toLowerCase()
					if ((text.includes('percentage') || text.includes('currency')) &&
						(text.includes('cheaper') || text.includes('expensive'))) {
						return parent
					}
				}
				parent = parent.parentElement
			}
			return el.parentElement?.parentElement
		},
		icon: 'icons',
		title: ES ? 'Leyenda y Filtros' : 'Legend & Filters',
		description: ES
			? 'Leyenda interactiva para la pestana activa. Haz clic en cualquier icono para filtrar las notificaciones por ese tipo de comparacion. La leyenda cambia segun el tipo de alerta seleccionado — cada pestana tiene su propio conjunto de filtros.'
			: 'Interactive legend for the active tab. Click any icon to filter notifications by that comparison type. The legend changes based on the selected alert type — each tab has its own set of filters.',
	},
	{
		type: 'field',
		findTarget: () => {
			const cards = document.querySelectorAll('.MuiCard-root, .MuiPaper-root')
			for (const card of cards) {
				const hasTitle = card.textContent.includes('Notifications: Price Comparison')
				const rows = card.querySelectorAll('table tbody tr')
				if (hasTitle && rows.length > 0 && !card.textContent.includes('no matching records')) {
					return card
				}
			}
			return null
		},
		icon: 'table-cells',
		title: ES ? 'Tabla de Notificaciones' : 'Notifications Table',
		description: ES
			? 'Cada fila es una notificacion activada. Las columnas varian segun el tipo de alerta pero normalmente incluyen: Nombre de Condicion, Fecha de Recogida, LOR, Categoria, ACRISS, Politica de Combustible, Transmision, Kilometraje, Descripcion del Coche, Sitio, Proveedor, Precio y Diferencia. Haz clic en el icono de busqueda en cualquier fila para verla en Busquedas en Tiempo Real.'
			: 'Each row is a triggered notification. Columns vary by alert type but typically include: Condition Name, Pickup Date, LOR, Category, ACRISS, Fuel Policy, Transmission, Mileage, Car Description, Site, Provider, Price, and Diff. Click the search icon on any row to view it in Real Time Searches.',
	},
	{
		type: 'field',
		findTarget: () => {
			const tables = document.querySelectorAll('table')
			for (const table of tables) {
				const rows = table.querySelectorAll('tbody tr')
				if (rows.length > 0 && !table.textContent.includes('no matching records')) {
					const headers = table.querySelectorAll('th')
					for (const h of headers) {
						if (h.textContent.trim().toLowerCase().includes('diff')) return h
					}
				}
			}
			return null
		},
		skipIf: () => {
			const tables = document.querySelectorAll('table')
			for (const table of tables) {
				if (!table.textContent.includes('no matching records')) {
					const headers = table.querySelectorAll('th')
					for (const h of headers) {
						if (h.textContent.trim().toLowerCase().includes('diff')) return false
					}
				}
			}
			return true
		},
		icon: 'magnifying-glass-chart',
		title: ES ? 'Diferencia y Enlace a Tiempo Real' : 'Diff & Real Time Link',
		description: ES
			? 'La columna Diff muestra el porcentaje de diferencia de precio. Junto a ella, un icono de busqueda enlaza directamente a la pagina de Busquedas en Tiempo Real filtrada a esa busqueda especifica — para que puedas ver el contexto completo de precios.'
			: 'The Diff column shows the price difference percentage. Next to it, a search icon links directly to the Real Time Searches page filtered to that specific search — so you can see the full pricing context.',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Selecciona un informe y una oficina para cargar las notificaciones. Cambia entre pestanas para ver los distintos tipos de alerta. Usa el icono de busqueda en cualquier notificacion para ir a su Busqueda en Tiempo Real con todo el contexto.'
			: 'Select a report and office to load notifications. Switch between tabs to see different alert types. Use the search icon on any notification to jump to its Real Time Search for full context.',
	},
]
